var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
export class Market {
    constructor(marketData) {
        this.id = marketData.id;
        this.selections = marketData.selections;
        this.name = marketData.name;
        this.type = marketData.type;
        this.typeId = marketData.typeId;
        this.eachWayText = marketData.eachWayText;
        this.tags = marketData.tags;
        this.betslipLine = marketData.betslipLine;
        this.isLive = marketData.isLive;
    }
    update(market) {
        this.name = market.name;
        this.id = market.id;
        this.type = market.type;
        let selections2remove = this.selections.map(m => m.id);
        let existingSelections = this.selections.map(m => m.id);
        for (let j = 0; j < market.selections.length; j++) {
            let selection2removeIndex = selections2remove.indexOf(market.selections[j].id);
            if (selection2removeIndex !== -1) {
                selections2remove.splice(selection2removeIndex, 1);
            }
            let existingSelectionIndex = existingSelections.indexOf(market.selections[j].id);
            existingSelectionIndex !== -1
                ? this.selections[existingSelectionIndex].update(market.selections[j])
                : this.selections.push(market.selections[j]);
        }
        /* istanbul ignore next */
        for (let i = 0; i < selections2remove.length; i++) {
            let existingMarketIndex = this.selections.map(s => s.id).indexOf(selections2remove[i]);
            this.selections.splice(existingMarketIndex, 1);
        }
    }
    get isDisabled() {
        return this.selections.every(sel => sel.isDisabled === true);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], Market.prototype, "tags", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], Market.prototype, "eachWayText", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Market.prototype, "selections", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Market]),
    __metadata("design:returntype", void 0)
], Market.prototype, "update", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Market.prototype, "isDisabled", null);
//# sourceMappingURL=Market.js.map